import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ListItem, CheckboxCircleArrowIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import ConfirmLink from "~/components/component.confirm_link";
import { convertToTask } from "~/store/actions/actions.discussions";

export const ConvertToTaskOption = ({ discussionId, projectId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const handleConvertToTask = useCallback(() => {
    dispatch(convertToTask(projectId, discussionId)).then((action) => {
      const newTaskId = action.response.result.single;
      const urlToTaskPageOrSheet = search.includes("modal")
        ? `?modal=Task-${newTaskId}-${projectId}`
        : `/projects/${projectId}/tasks/${newTaskId}`;
      navigate(urlToTaskPageOrSheet);
    });
  }, [dispatch, projectId, discussionId, navigate, search]);

  return (
    <ConfirmLink
      data-testid="confirm-dialogue"
      className="tw-no-underline"
      title={t("Convert discussion to task?")}
      description={t(
        "Converting discussion to task will transfer all the comments, files and subscriptions to the new task."
      )}
      confirmLabel={t("Convert to task")}
      cancelLabel={t("Cancel")}
      onClick={handleConvertToTask}
    >
      <ListItem>
        <CheckboxCircleArrowIcon className="tw-fill-theme-900" />
        {t("Convert to Task")}
      </ListItem>
    </ConfirmLink>
  );
};

ConvertToTaskOption.propTypes = {
  onConvertToTask: PropTypes.func,
  discussionId: PropTypes.number,
  projectId: PropTypes.number,
};
